import {createContext} from 'react'

const StockChangeProductContext = createContext<{
  disabled: boolean
}>({
  disabled: false,
})

export default StockChangeProductContext
